import React, { useEffect, useState } from "react";
import { ListOrder } from "../../../Utility/Api";
import {useLocation} from "react-router-dom";
import { NaviGate } from "../../../Utility/function";

const ReturnList = () => {
    const location = useLocation()
    const {state} = location
    const [Order, setOrder] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedReturnInvoice, setSelectedReturnInvoice] = useState(null);

    useEffect(()=>{
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        try {
            const response = await ListOrder(state.unique_id);
            if (response.data && response.data.data) {
                setOrder(response.data.data);
            }
            if(response.data && response.data.return_sale){
                setSelectedReturnInvoice(response.data.return_sale)
              }
        } catch (error) {
            console.error("Error fetching Customer data:", error);
        }
    };
    const filteredOrders = Order.filter(
        (order) =>
            order.product_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            order.customer_name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="page-wrappers">
            <div className="page-content py-1">
                <NaviGate />
                <div className="px-0 py-1 col-12">
                    <div
                        className="row justify-content-center row-gap-3 py-2"
                        style={{ background: "rgb(241, 243, 245)" }}
                    >
                        <div className="col-md-6 position-relative">
                            <div>
                                <div
                                    className="w-100"
                                    style={{ position: "relative", display: "inline-block" }}
                                >
                                    <input
                                        type="text"
                                        className="w-100"
                                        placeholder="Search"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{
                                            borderRadius: 1,
                                            border: "1px solid rgb(204, 204, 204)",
                                        }}
                                    />
                                    <img
                                        src="/assets/images/icons/search.png"
                                        alt="Search Icon"
                                        style={{
                                            position: "absolute",
                                            right: 10,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            height: 18,
                                            pointerEvents: "none",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="table-responsive text-center my-1 w-100 position-relative"
                        style={{ overflowX: "hidden", minHeight: "70vh" }}
                    >
                        <table className="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Unique No</th>
                                    <th>Product Name</th>
                                    <th>Customer</th>
                                    <th>sales Price</th>
                                    <th>Qty</th>
                                    <th>Sold/Return</th>
                                    <th>Total Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredOrders.map((order, index) => (
                                    <tr key={order.id}>
                                        <td>{index + 1}</td>
                                        <td>{order.unique_id || "N/A"}</td>
                                        <td>{order.product_name || "N/A"}</td>
                                        <td>{order.customer_name || "N/A"}</td>
                                        <td>{order.sales_price || "N/A"}</td>
                                        <td>{order.qty || "N/A"}</td>
                                        <td>{order.type == 2 ? 'Returned': 'Sold' || "N/A"}</td>
                                        <td className={`${order.type == 2 ? 'text-danger':''}`}>{order.amount_per_price || "N/A"}</td>
                                    </tr>
                                ))}
                                {selectedReturnInvoice?.length > 0 &&
                           <tr>
                              <td colSpan="8" className="text-center">
                                <strong>Return Products</strong>
                              </td>
                            </tr>}
                                    
                            {Array.isArray(selectedReturnInvoice) &&
                              selectedReturnInvoice.map((item, index) => (
                                <tr key={`additional-product-${index}`}>
                                  <td>{index+1}</td>  
                                  <td>{item.status}</td>  
                                  <td>{item.product_name}</td>  
                                  <td>{item.customer_name}</td>  
                                  <td>{item.sales_price}</td>  
                                  <td>{item.returnQty}</td>  
                                  <td>{"Replaced"}</td>
                                  <td className="text-danger">{"- "+item.returnAmount || "N/A"}</td>
                                </tr>
                              ))}
                              {selectedReturnInvoice?.length > 0 &&
                              <tr>
                                <td colSpan="7" className="text-end">Total Amount</td>
                              <td colSpan="1" className="text-center">
                                <strong>{state.total}</strong>
                              </td>
                              </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReturnList;
